import React, { useEffect, useState } from 'react';
import './ProfileDetail.scss';
import './TabsProfile.scss';
import { useTranslation } from 'react-i18next';
import { useLoading } from '../../../commons/Loading';
import { useAlert } from 'react-alert';
import { useAuth } from '../../../commons/Auth';
import {
  NumberParam,
  StringParam,
  useQueryParams,
  withDefault,
} from 'use-query-params';
import { Nav, NavItem, NavLink, TabContent, TabPane } from 'reactstrap';
import classNames from 'classnames';
import { Link, Route, Switch, Redirect } from 'react-router-dom';
import SignalsCondo from './SignalsCondo';
import { withRouter } from 'react-router-dom';
import axios from 'axios';
import SignalsSpecialJobs from './SignalsSpecialJobs';
import SignalsRentalsSales from './SignalsRentalsSales';
import { ADMIN_TYPES } from '../../../App';

const { REACT_APP_DEFAULT_PAGINATION_LIMIT = 50 } = process.env;

const Signals = (props) => {
  const [t] = useTranslation('SIGNALS');
  const { showLoading, hideLoading } = useLoading();
  const alert = useAlert();
  const [{ newToken, newIsAdmin } = {}] = useAuth();

  const { history, location, match = {}, profile } = props;
  const { type: profileType = '' } = profile;
  const { params: { id } = {}, url = '' } = match;
  const { pathname = '', state = {} } = location;
  const tab = pathname.split('/').pop();

  const [signals, setSignals] = useState([]);
  const [total, setTotal] = useState(0);

  const [selectedSignals, setSelectedSignals] = useState([]);
  const [checkedRows, setCheckedRows] = useState([]);
  const [selectedAll, setSelectedAll] = useState(false);

  const [query, setQuery] = useQueryParams({
    signalman: withDefault(StringParam, ''),
    admin: withDefault(StringParam, ''),
    commercial: withDefault(StringParam, ''),
    condo: withDefault(StringParam, ''),
    signalTypeCode: withDefault(StringParam, 'CONDO'),
    accountabilityYear: NumberParam,
    accountabilityMonth: NumberParam,
    notes: withDefault(StringParam, ''),
    limit: withDefault(NumberParam, +REACT_APP_DEFAULT_PAGINATION_LIMIT),
    offset: NumberParam,
  });

  const {
    signalman,
    commercial,
    admin,
    condo,
    signalTypeCode,
    accountabilityYear,
    accountabilityMonth,
    notes,
    limit,
    offset,
  } = query;

  function onFilter(queryDiff) {
    if (
      (queryDiff.signalman && queryDiff.signalman !== signalman) ||
      (signalman && queryDiff.signalman === '') ||
      (queryDiff.commercial && queryDiff.commercial !== commercial) ||
      (commercial && queryDiff.commercial === '') ||
      (queryDiff.admin && queryDiff.admin !== admin) ||
      (admin && queryDiff.admin === '') ||
      (queryDiff.notes && queryDiff.notes !== notes) ||
      (notes && queryDiff.notes === '') ||
      (queryDiff.condo && queryDiff.condo !== condo) ||
      (condo && queryDiff.condo === '') ||
      (queryDiff.signalTypeCode &&
        queryDiff.signalTypeCode !== signalTypeCode) ||
      (signalTypeCode && queryDiff.signalTypeCode === '') ||
      (queryDiff.accountabilityYear &&
        queryDiff.accountabilityYear !== accountabilityYear) ||
      (accountabilityYear && queryDiff.accountabilityYear === '') ||
      (queryDiff.accountabilityMonth &&
        queryDiff.accountabilityMonth !== accountabilityMonth) ||
      (accountabilityMonth && queryDiff.accountabilityMonth === '') ||
      (queryDiff.limit && queryDiff.limit !== limit)
    ) {
      queryDiff.offset = 0; // return to first page
    }

    setQuery(queryDiff);
  }

  const fetchSignals = async (query) => {
    showLoading();

    const response = await axios.get(
      `${process.env.REACT_APP_API_URL}/signals/admin/${profile._id}`,
      {
        headers: { Authorization: newToken },
        params: {
          ...query,
        },
      }
    );

    hideLoading();

    if (response instanceof Error) {
      return alert.error(t('COMMON:GENERIC_ERROR'));
    }

    const { data = [], headers = {} } = response;
    setSignals(data.signals || []);
    setTotal(+headers['x-total-count']);
  };

  const onSelectChange = (row) => {
    if (selectedSignals.includes(row._id)) {
      setSelectedAll(false);
      setCheckedRows((checkedRows) =>
        checkedRows.filter(({ _id }) => _id !== row._id)
      );
      return setSelectedSignals((selectedSignals) =>
        selectedSignals.filter((signalId) => signalId !== row._id)
      );
    }
    setSelectedSignals((selectedSignals) => [...selectedSignals, row._id]);
    setCheckedRows((checkedRows) => [...checkedRows, row]);
  };

  const onSelectAll = (selectAll) => {
    setSelectedAll(selectAll);
    if (!selectAll) {
      setCheckedRows([]);
      return setSelectedSignals([]);
    }
    setCheckedRows(signals.filter((signal) => !signal.extraInvoiceId));
    setSelectedSignals(
      signals.filter((signal) => !signal.extraInvoiceId).map(({ _id }) => _id)
    );
  };

  const onRowClick = (row) => {
    const { _id } = row;
    if (!row.extraInvoiceId) {
      onSelectChange(row);
    }
  };

  const onInvoice = async () => {
    showLoading();

    const response = await axios.post(
      `${process.env.REACT_APP_API_URL}/extra-invoices/${profile._id}/signals`,
      {
        selectedSignals,
      },
      {
        headers: { Authorization: newToken },
      }
    );
    hideLoading();

    if (response instanceof Error) {
      return alert.error(t('COMMON:GENERIC_ERROR'));
    }

    alert.success(t('COMMON:SUCCESS_UPDATE'));

    fetchSignals(query);
    setSelectedSignals([]);
    setSelectedAll(false);
  };

  useEffect(() => {
    if (profile._id) {
      fetchSignals(query);
    }
  }, [
    signalman,
    commercial,
    admin,
    condo,
    signalTypeCode,
    accountabilityYear,
    accountabilityMonth,
    notes,
    limit,
    offset,
  ]);

  if (pathname === url) {
    if (ADMIN_TYPES.includes(profile.type)) {
      return <Redirect to={`${url}/signals-condo`} />;
    } else if (
      ['SUPPLIER', 'EON_ENERGY', 'ASSOCIATION', 'COMMERCIAL'].includes(
        profile.type
      )
    ) {
      return <Redirect to={`${url}/signals-special-jobs`} />;
    } else if (['AGENCY', 'COMMERCIAL', 'ASSOCIATION'].includes(profile.type)) {
      return <Redirect to={`${url}/signals-rentals-sales`} />;
    }
  }

  return (
    <section>
      <TabContent activeTab={'1'}>
        <TabPane tabId="1">
          <section>
            <div className="m-tb-5">
              <Nav style={{ backgroundColor: '#F3F3F3' }} tabs>
                {ADMIN_TYPES.includes(profile.type) && (
                  <NavItem>
                    <NavLink
                      tag={Link}
                      to={`${match.url}/signals-condo?signalTypeCode=CONDO`}
                      className={classNames({
                        active: tab === 'signals-condo',
                      })}
                    >
                      {t('PAGES:SIGNALS_CONDO_TAB')}
                    </NavLink>
                  </NavItem>
                )}

                {[
                  'SUPPLIER',
                  'EON_ENERGY',
                  'ASSOCIATION',
                  'COMMERCIAL',
                ].includes(profile.type) && (
                  <NavItem>
                    <NavLink
                      tag={Link}
                      to={`${match.url}/signals-special-jobs?signalTypeCode=SPECIAL_JOBS`}
                      className={classNames({
                        active: tab === 'signals-special-jobs',
                      })}
                    >
                      {t('PAGES:SIGNALS_SPECIAL_JOBS_TAB')}
                    </NavLink>
                  </NavItem>
                )}

                {['AGENCY', 'COMMERCIAL', 'ASSOCIATION'].includes(
                  profile.type
                ) && (
                  <NavItem>
                    <NavLink
                      tag={Link}
                      to={`${match.url}/signals-rentals-sales?signalTypeCode=RENTALS_SALES`}
                      className={classNames({
                        active: tab === 'signals-rentals-sales',
                      })}
                    >
                      {t('PAGES:SIGNALS_RENTALS_SALES_TAB')}
                    </NavLink>
                  </NavItem>
                )}
              </Nav>

              <Switch>
                <Route
                  path={`${match.url}/signals-condo`}
                  component={(props) => (
                    <SignalsCondo
                      signals={signals}
                      query={query}
                      total={total}
                      onFilter={onFilter}
                      selectedSignals={selectedSignals}
                      onSelectAll={onSelectAll}
                      onRowClick={onRowClick}
                      onInvoice={onInvoice}
                      selectedAll={selectedAll}
                      onStatusChanged={() => fetchSignals(query)}
                      {...props}
                    />
                  )}
                />

                <Route
                  path={`${match.url}/signals-special-jobs`}
                  component={(props) => (
                    <SignalsSpecialJobs
                      signals={signals}
                      query={query}
                      total={total}
                      onFilter={onFilter}
                      selectedSignals={selectedSignals}
                      onSelectAll={onSelectAll}
                      onRowClick={onRowClick}
                      onInvoice={onInvoice}
                      selectedAll={selectedAll}
                      onStatusChanged={() => fetchSignals(query)}
                      {...props}
                    />
                  )}
                />

                <Route
                  path={`${match.url}/signals-rentals-sales`}
                  component={(props) => (
                    <SignalsRentalsSales
                      signals={signals}
                      query={query}
                      total={total}
                      onFilter={onFilter}
                      selectedSignals={selectedSignals}
                      onSelectAll={onSelectAll}
                      onRowClick={onRowClick}
                      onInvoice={onInvoice}
                      selectedAll={selectedAll}
                      onStatusChanged={() => fetchSignals(query)}
                      {...props}
                    />
                  )}
                />
              </Switch>
            </div>
          </section>
        </TabPane>
      </TabContent>
    </section>
  );
};

export default withRouter(Signals);
